<template>
  <div class="row shadow-none">
    <div class="col">
      <div :class="['be-loading', { 'be-loading-active': isBusy }]">
        <div
          class="flex flex-col md:flex-row md:justify-between md:items-center gap-[10px] md:gap-0 mb-2"
        >
          <div class="flex flex-col gap-[16px]">
            <button
              class="text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px] border-b-2 border-[#2463EB] text-[#2463EB] max-w-max"
            >
              Branches
            </button>
            <p class="text-[#353535] text-[14px] leading-[20px] font-semibold">
              Manage All Branches here
            </p>
          </div>
          <div>
            <button
              class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none max-w-max w-full"
              @click="viewAdd"
              v-if="hasPermission('Branch_Create')"
            >
              <i class="feather icon-plus"></i> &nbsp;New Branch
            </button>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-fw-widget dataTable no-footer text-nowrap">
            <thead>
              <tr>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Name
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Address
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Phone
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Email
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Status
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Created
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="12" class="text-center">
                  <div
                    class="text-center"
                    style="padding-top: 100px; padding-bottom: 50px"
                  >
                    <span
                      class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                      style="font-size: 8rem"
                    ></span>
                    <h3
                      class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                      style="padding-bottom: 100px"
                    >
                      Please wait while we load your distributor's list
                    </h3>
                  </div>
                </td>
              </tr>
              <tr v-for="l in Branches" :key="l.id" v-else>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ l.name }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ l.address }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ l.phoneNumber }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ l.email }}
                </td>
                <td>
                  <span
                    class="flex items-center gap-[4px] max-w-max w-full"
                    :class="[
                      'badge',
                      {
                        'badge-success': l.active,
                        'badge-danger': !l.active,
                      },
                    ]"
                  >
                    <span
                      class="w-[10px] h-[10px] rounded-[1px]"
                      :style="{
                        backgroundColor: l.active ? '#16a249' : '#EF5253',
                      }"
                    ></span>
                    <span class="text-[12px] font-normal leading-[16.94px]">{{
                      l.active ? "Active" : "Inactive"
                    }}</span>
                  </span>
                </td>
                <!--<td>{{ l.parent? l.parent.name : 'System' }}</td>-->
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ formatDate(l.created) }}
                </td>
                <td>
                  <button
                    class="btn-no-border"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span
                      class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none"
                    >
                      ...
                    </span>
                  </button>
                  <ul
                    class="dropdown-menu shadow-none"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <li
                      class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[10px] px-[16px] border-b"
                      v-if="
                        hasPermission('Branch_Update') &&
                          l.parentId == user.parentId
                      "
                      @click.prevent="viewEdit(l)"
                    >
                      Edit
                    </li>
                    <li
                      class="text-[14px] font-normal leading-[20px] text-[#DC2828] cursor-pointer py-[10px] px-[16px]"
                      href="#"
                      v-if="hasPermission('Branch_Delete')"
                      @click.prevent="confirmDelete(l.id)"
                    >
                      Delete Branch
                    </li>
                  </ul>
                </td>
              </tr>
              <tr v-if="!Branches.length && !loading">
                <td colspan="7">
                  <div class="text-center" style="padding-top:50px;">
                    <span
                      style="font-size: 4.615rem;"
                      class="mdi mdi-crosshairs-gps"
                    ></span>
                  </div>
                  <h3 class="text-center" style="padding-bottom:100px;">
                    You don't have any branches.
                  </h3>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination
            :limit="pageSize"
            :count="pageCount"
            :page="page"
            :itemsCount="count"
            @changePage="gotoPage"
            @changeLimit="changeLimit"
          />
        </div>
      </div>
    </div>

    <div class="modal" id="mod-add" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
        >
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Create new Branch
            </h4>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Name</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v1.name }]"
                  type="text"
                  v-model="createBranch.name"
                  placeholder="Enter branch name"
                />
                <ul v-if="v1.name" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Address</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v1.address }]"
                  type="text"
                  v-model="createBranch.address"
                  placeholder="Enter branch address"
                />
                <ul v-if="v1.address" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Email</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v1.email }]"
                  type="text"
                  v-model="createBranch.email"
                  placeholder="Enter branch email address"
                />
                <ul v-if="v1.email" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
                <ul
                  v-if="v1.emailAddressValid"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">Enter a valid email address.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[10px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Phone</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v1.phone }]"
                  type="text"
                  v-model="createBranch.phone"
                  placeholder="Enter branch phone number"
                />
                <ul v-if="v1.phone" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
                <ul
                  v-if="v1.phoneNumberValid"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">Enter a valid phone number.</li>
                </ul>
              </div>
            </div>
            <div
              class="flex items-center gap-[10px] max-w-max"
              @click="createBranch.active = !createBranch.active"
            >
              <button
                type="button"
                class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer w-11 focus:outline-none"
                role="switch"
                :aria-checked="createBranch.active"
                :class="{
                  'bg-[#2463eb]': createBranch.active,
                  'bg-[#E4E4E7]': !createBranch.active,
                }"
              >
                <span
                  aria-hidden="true"
                  class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform bg-gray-400 rounded-full pointer-events-none"
                  :class="{
                    'translate-x-5 bg-white': createBranch.active,
                    'translate-x-0 bg-gray-400': !createBranch.active,
                  }"
                ></span>
              </button>
              <span class="cursor-pointer">
                <span
                  class="text-[#353535] text-[16px] font-normal leading-[20px]"
                >
                  This branch is active
                </span>
              </span>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[32px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="create"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Add branch</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-edit" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
        >
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Edit Branch
            </h4>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Name</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v2.name }]"
                  type="text"
                  v-model="updateBranch.name"
                  placeholder="Enter branch name"
                />
                <ul v-if="v2.name" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Address</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v2.address }]"
                  type="text"
                  v-model="updateBranch.address"
                  placeholder="Enter branch address"
                />
                <ul v-if="v2.address" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Email</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v2.email }]"
                  type="text"
                  v-model="updateBranch.email"
                  placeholder="Enter branch email address"
                />
                <ul v-if="v2.email" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
                <ul
                  v-if="v2.emailAddressValid"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">Enter a valid email address.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Phone</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v2.phone }]"
                  type="text"
                  v-model="updateBranch.phone"
                  placeholder="Enter branch phone number"
                />
                <ul v-if="v2.phone" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
                <ul
                  v-if="v2.phoneNumberValid"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">Enter a valid phone number.</li>
                </ul>
              </div>
            </div>
            <div
              class="flex items-center gap-[10px] max-w-max"
              @click="updateBranch.active = !updateBranch.active"
            >
              <button
                type="button"
                class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer w-11 focus:outline-none"
                role="switch"
                :aria-checked="updateBranch.active"
                :class="{
                  'bg-[#2463eb]': updateBranch.active,
                  'bg-[#E4E4E7]': !updateBranch.active,
                }"
              >
                <span
                  aria-hidden="true"
                  class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform bg-gray-400 rounded-full pointer-events-none"
                  :class="{
                    'translate-x-5 bg-white': updateBranch.active,
                    'translate-x-0 bg-gray-400': !updateBranch.active,
                  }"
                ></span>
              </button>
              <span class="cursor-pointer">
                <span
                  class="text-[#353535] text-[16px] font-normal leading-[20px]"
                >
                  This branch is active
                </span>
              </span>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[32px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="update"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade colored-header colored-header-primary"
      id="mod-filter"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header modal-header-colored">
            <h3 class="modal-title">Filter</h3>
            <button
              class="close md-close"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Status</label
              >
              <div>
                <select
                  class="form-control"
                  placeholder="Select an option"
                  v-model="filter.status"
                >
                  <option value="0">All Branches</option>
                  <option value="True">Active</option>
                  <option value="False">Disabled</option>
                </select>
              </div>
            </div>

            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Other filters</label
              >
              <div>
                <input
                  class="form-control"
                  type="text"
                  placeholder="Filter by name..."
                  v-model="filter.qry"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="width: 100px;"
              class="btn btn-secondary md-close"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              style="width: 100px;"
              class="btn btn-secondary md-close"
              type="button"
              @click="reset"
            >
              Reset
            </button>
            <button
              style="width: 100px;"
              class="btn btn-primary md-close"
              type="button"
              @click="getBranches"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
    <GeneralDeleteCaution
      :id="DeleteId"
      @proceed="deleteBranch"
      :isBusy="isBusyModal"
      text="branch"
    />
  </div>
</template>

<script>
/* eslint-disable */

import moment from "moment";
import { helper } from "@/helper";
import Select2 from "@/components/Select2";
import GeneralDeleteCaution from "../components/GeneralDeleteCaution.vue";
import GeneralDeleteMessage from "../components/GeneralDeleteMessage.vue";
import Pagination from "../components/Pagination.vue";
import SystemPermissions from "@/permissions";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "settingsBranches",
  components: {
    Select2,
    GeneralDeleteCaution,
    GeneralDeleteMessage,
    Pagination,
  },
  created() {
    if (!this.hasPermission("Branch_View")) {
      this.$router.push("/restricted");
    }
    this.getBranches();
  },
  watch: {},
  data() {
    return {
      filter: {
        status: "0",
        qry: "",
      },
      isBusy: false,
      isBusyModal: false,
      createBranch: {
        name: null,
        address: null,
        phone: null,
        email: null,
        active: null,
      },
      updateBranch: {
        name: null,
        address: null,
        phone: null,
        email: null,
        active: true,
        id: null,
      },
      v1: {
        name: false,
        address: false,
        emailAddressValid: false,
        phoneNumberValid: false,
      },
      v2: {
        name: false,
        address: false,
        emailAddressValid: false,
        phoneNumberValid: false,
      },
      Branches: [],
      DeleteId: "",
      count: 0,
      page: 1,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
      loading: false,
    };
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },
  methods: {
    reset() {
      this.filter = {
        status: "0",
        qry: "",
      };
    },
    confirmDelete(id) {
      this.DeleteId = id;
      $("#mod-confirm-delete").modal("show");
    },

    showDeleteMsg() {
      $("#mod-delete-msg").modal("show");
    },

    cancelConfirm() {
      this.DeleteId = "";
      $("#mod-confirm-delete").modal("hide");
    },
    async deleteBranch() {
      this.isBusyModal = true;
      try {
        const res = await this.$http.delete(`/Branches/${this.DeleteId}`);
        if (res.ok) {
          this.$toast.success("Branch deleted successfully", {
            icon: true,
            rtl: false,
          });
          this.getBranches();
          this.cancelConfirm();
        }
      } catch (error) {
        this.cancelConfirm();
        this.showDeleteMsg();
      }
      this.isBusyModal = false;
    },
    viewExport() {
      //   $("#mod-export").modal("show");
    },
    viewAdd() {
      this.createBranch = {
        name: null,
        address: null,
        phone: null,
        email: null,
        active: false,
      };
      this.v1 = {
        name: false,
        address: false,
      };
      $("#mod-add").modal("show");
    },
    viewEdit(c) {
      this.updateBranch = c;
      this.updateBranch.phone = c.phoneNumber;
      $("#mod-edit").modal("show");
    },
    viewFilter() {
      this.page = 0;
      $("#mod-filter").modal("show");
    },
    async create() {
      this.isBusyModal = true;
      this.isBusy = true;

      var data = {
        name: this.createBranch.name,
        address: this.createBranch.address,
        email: this.createBranch.email,
        phone: this.createBranch.phone,
        active: this.createBranch.active,
        parentId: this.user.parentId,
      };

      if (this.validateCreate()) {
        $("#mod-add").modal("hide");

        await this.$http
          .post("/Branches/create", data)
          .then(function(res) {
            this.isBusyModal = false;
          })
          .catch(function() {});

        this.getBranches();
      }

      this.isBusy = false;
      this.isBusyModal = false;
    },
    validateCreate() {
      this.v1 = {
        name: false,
        address: false,
      };
      var isValid = true;

      if (!this.createBranch.name) {
        this.v1.name = true;
        isValid = false;
      }

      if (!this.createBranch.address) {
        this.v1.address = true;
        isValid = false;
      }

      if (
        this.createBranch.email &&
        !helper.validateEmail(this.createBranch.email)
      ) {
        this.v1.emailAddressValid = true;
        isValid = false;
      }

      if (
        this.createBranch.phone &&
        !helper.validatePhone(this.createBranch.phone)
      ) {
        this.v1.phoneNumberValid = true;
        isValid = false;
      }

      return isValid;
    },
    async update() {
      this.isBusyModal = true;
      this.isBusy = true;

      var data = {
        name: this.updateBranch.name,
        address: this.updateBranch.address,
        email: this.updateBranch.email,
        phone: this.updateBranch.phone,
        active: this.updateBranch.active,
        id: this.updateBranch.id,
      };

      if (this.validateUpdate()) {
        $("#mod-edit").modal("hide");

        await this.$http
          .put("/Branches/update/" + data.id, data)
          .then(function(res) {
            this.isBusyModal = false;
          })
          .catch(function() {});

        this.getBranches();
      }

      this.isBusy = false;
      this.isBusyModal = false;
    },
    validateUpdate() {
      this.v2 = {
        name: false,
      };
      var isValid = true;

      if (!this.updateBranch.name) {
        this.v2.name = true;
        isValid = false;
      }

      if (!this.updateBranch.address) {
        this.v2.address = true;
        isValid = false;
      }

      if (
        this.updateBranch.email &&
        !helper.validateEmail(this.updateBranch.email)
      ) {
        this.v2.emailAddressValid = true;
        isValid = false;
      }

      if (
        this.updateBranch.phone &&
        !helper.validatePhone(this.updateBranch.phone)
      ) {
        this.v2.phoneNumberValid = true;
        isValid = false;
      }

      return isValid;
    },
    async getBranches() {
      this.isBusy = true;
      this.loading = true;
      await this.$http
        .get(
          "/Branches/getList?page=" +
            (this.page - 1) +
            "&pageSize=" +
            this.pageSize +
            (this.filter.status != "0" ? "&active=" + this.filter.status : "") +
            (this.filter.qry != "" ? "&query=" + this.filter.qry : "") +
            (this.user.parentId ? "&parentId=" + this.user.parentId : "")
        )
        .then(function(res) {
          this.Branches = res.body.data;
          this.page = res.body.page + 1;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.isBusy = false;
          this.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });

      $("#mod-filter").modal("hide");
      this.isBusy = false;
    },
    formatDate(date) {
      return moment(date).format("ll");
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
    prev() {
      this.page -= 1;
      this.getBranches();
    },
    next() {
      this.page += 1;
      this.getBranches();
    },

    gotoPage(page) {
      this.page = page;
      this.getBranches();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.getBranches();
    },
  },
};
</script>
